"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowClient = void 0;
var fetch_helper_1 = require("src/helpers/fetch-helper");
var CLIENT_NAME = 'WorkflowClient';
// Leaving this string here for now because I want to split these clients a little
// more to help with tree shaking (@TODO)
var URL_ROOT = '/domo/workflow/v1/models';
var POST_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
function getAllModels(includePermissions) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, (0, fetch_helper_1.fetchWithLog)(CLIENT_NAME, function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, fetch((0, fetch_helper_1.buildURL)(URL_ROOT, {
                                parts: includePermissions === true ? ['users'] : undefined,
                            }), {
                                method: 'GET',
                            })];
                    });
                }); })];
        });
    });
}
var getModelDetails = function (workflowAlias) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, fetch_helper_1.fetchWithLog)(CLIENT_NAME, function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, fetch((0, fetch_helper_1.buildURL)("".concat(URL_ROOT, "/").concat(workflowAlias, "/overall")), {
                            method: 'GET',
                        })];
                });
            }); })];
    });
}); };
var getInstance = function (workflowAlias, instanceId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, fetch_helper_1.fetchWithLog)(CLIENT_NAME, function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, fetch((0, fetch_helper_1.buildURL)("".concat(URL_ROOT, "/").concat(workflowAlias, "/instance/").concat(instanceId)), {
                            method: 'GET',
                        })];
                });
            }); })];
    });
}); };
var startModel = function (workflowAlias, variables) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, fetch_helper_1.fetchWithLog)(CLIENT_NAME, function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, fetch((0, fetch_helper_1.buildURL)("".concat(URL_ROOT, "/").concat(workflowAlias, "/start")), {
                            method: 'POST',
                            headers: POST_HEADERS,
                            body: JSON.stringify(variables),
                        })];
                });
            }); })];
    });
}); };
/** @namespace
 *
 * ## Utilities for helping your app interact with Workflows.
 *
 * @example
 * ```typescript
 * import { WorkflowClient } from @domoinc/toolkit;
 *
 * const WORKFLOW_ALIAS = 'testWorkflow';
 * const MODEL_INSTANCE_ID = 'dc8fa95d-746f-226f-98a9-4693da393a22';
 *
 * /**
 *  * Get all models in the instance
 *  *   @param includePermissions Define is the permissions for the current user should be attached
 *  *\/
 * await WorkflowClient.getAllModels(true);
 *
 * /**
 *  * Get details for single workflow model. Includes information about instances of the model.
 *  *   @param workflowAlias Defined in the manifest, under `mappings`
 *  *\/
 * await WorkflowClient.getModelDetails(WORKFLOW_ALIAS);
 *
 * /**
 *  * Get details for single instance (i.e. an execution) of a workflow model
 *  *   @param workflowAlias Defined in the manifest, under `mappings`
 *  *   @param instanceId Unique UUID that identifies a single instance of the workflow
 *  *\/
 * await WorkflowClient.getInstance(WORKFLOW_ALIAS, MODEL_INSTANCE_ID);
 *
 * /**
 *  * Trigger a manual instance of the workflow model (i.e. execute it once, manually)
 *  *   @param workflowAlias Defined in the manifest, under `mappings`
 *  *   @param variables Key-pair set of inputs for the start node of the workflow
 *  *\/
 * await WorkflowClient.startModel(WORKFLOW_ALIAS, { exampleInput: 1000 });
 * ```
 */
exports.WorkflowClient = {
    getAllModels: getAllModels,
    getModelDetails: getModelDetails,
    getInstance: getInstance,
    startModel: startModel,
};
